import type { User } from '#auth-utils'

export function isAdmin(user: MaybeRef<Pick<User, 'role'> | undefined | null>) {
  const raw = unref(user)

  // Yes, admins are teachers...
  return !!raw?.role?.includes('teacher')
}
